import { render, staticRenderFns } from "./ViewComplianceUpdate.vue?vue&type=template&id=67b05a08&"
import script from "./ViewComplianceUpdate.vue?vue&type=script&lang=js&"
export * from "./ViewComplianceUpdate.vue?vue&type=script&lang=js&"
import style0 from "./ViewComplianceUpdate.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports